"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JITA_SETTINGS_WRITE = exports.JITA_SETTINGS_READ = exports.TWO_FACTOR_AUTH_REQUIREMENT_WRITE = exports.TWO_FACTOR_AUTH_REQUIREMENT_READ = exports.SINGLE_SIGN_ON_REQUIRE = exports.SINGLE_SIGN_ON_REQUIREMENT_WRITE = exports.SINGLE_SIGN_ON_REQUIREMENT_READ = exports.SINGLE_SIGN_ON_SETTINGS_WRITE = exports.SINGLE_SIGN_ON_SETTINGS_READ = exports.MULTI_CURRENCY_WRITE = exports.MULTI_CURRENCY_READ = exports.MULTI_CURRENCY_GATE = exports.UNIFIED_BRANDING_ADDITIONAL_FIELDS_GATE = exports.WRITE = exports.READ = exports.SCOPES = void 0;
var SCOPES = {
  READ: 'account-defaults-settings-read',
  WRITE: 'account-defaults-settings-write'
};
exports.SCOPES = SCOPES;
var READ = {
  matchesAllScopes: [SCOPES.READ]
};
exports.READ = READ;
var WRITE = {
  matchesAllScopes: [SCOPES.WRITE]
};
exports.WRITE = WRITE;
var UNIFIED_BRANDING_ADDITIONAL_FIELDS_GATE = {
  matchesAllGates: ['settings-ui:unified-branding-additional-fields']
};
exports.UNIFIED_BRANDING_ADDITIONAL_FIELDS_GATE = UNIFIED_BRANDING_ADDITIONAL_FIELDS_GATE;
var MULTI_CURRENCY_GATE = {
  matchesSomeGates: ['SalesEnterprise:EarlyAccess', 'MarketingEnterprise:EarlyAccess']
};
exports.MULTI_CURRENCY_GATE = MULTI_CURRENCY_GATE;
var MULTI_CURRENCY_READ = {
  and: [{
    matchesSomeGates: ['SalesEnterprise:EarlyAccess', 'MarketingEnterprise:EarlyAccess']
  }, {
    matchesAllScopes: ['multi-currency-read']
  }]
};
exports.MULTI_CURRENCY_READ = MULTI_CURRENCY_READ;
var MULTI_CURRENCY_WRITE = {
  and: [{
    matchesSomeGates: ['SalesEnterprise:EarlyAccess', 'MarketingEnterprise:EarlyAccess']
  }, {
    matchesAllScopes: ['multi-currency-write']
  }]
};
exports.MULTI_CURRENCY_WRITE = MULTI_CURRENCY_WRITE;
var SINGLE_SIGN_ON_SETTINGS_READ = {
  matchesAllScopes: ['sso-settings-read']
};
exports.SINGLE_SIGN_ON_SETTINGS_READ = SINGLE_SIGN_ON_SETTINGS_READ;
var SINGLE_SIGN_ON_SETTINGS_WRITE = {
  matchesAllScopes: ['sso-settings-write']
};
exports.SINGLE_SIGN_ON_SETTINGS_WRITE = SINGLE_SIGN_ON_SETTINGS_WRITE;
var SINGLE_SIGN_ON_REQUIREMENT_READ = {
  matchesAllScopes: ['sso-settings-read']
};
exports.SINGLE_SIGN_ON_REQUIREMENT_READ = SINGLE_SIGN_ON_REQUIREMENT_READ;
var SINGLE_SIGN_ON_REQUIREMENT_WRITE = {
  matchesAllScopes: ['sso-settings-write']
};
exports.SINGLE_SIGN_ON_REQUIREMENT_WRITE = SINGLE_SIGN_ON_REQUIREMENT_WRITE;
var SINGLE_SIGN_ON_REQUIRE = {
  matchesAllScopes: ['sso-require-write', 'sso-settings-write']
};
exports.SINGLE_SIGN_ON_REQUIRE = SINGLE_SIGN_ON_REQUIRE;
var TWO_FACTOR_AUTH_REQUIREMENT_READ = {
  matchesAllGates: ['settings-ui:2fa-require']
};
exports.TWO_FACTOR_AUTH_REQUIREMENT_READ = TWO_FACTOR_AUTH_REQUIREMENT_READ;
var TWO_FACTOR_AUTH_REQUIREMENT_WRITE = {
  and: [{
    matchesAllGates: ['settings-ui:2fa-require']
  }, {
    matchesAllScopes: ['two-factor-required-hubs-write']
  }]
};
exports.TWO_FACTOR_AUTH_REQUIREMENT_WRITE = TWO_FACTOR_AUTH_REQUIREMENT_WRITE;
var JITA_SETTINGS_READ = {
  and: [{
    matchesAllGates: ['settings-ui:jita-enable-disable']
  }, {
    matchesAllScopes: ['hub-jita-settings-read']
  }]
};
exports.JITA_SETTINGS_READ = JITA_SETTINGS_READ;
var JITA_SETTINGS_WRITE = {
  and: [{
    matchesAllGates: ['settings-ui:jita-enable-disable']
  }, {
    matchesAllScopes: ['hub-jita-settings-write']
  }]
};
exports.JITA_SETTINGS_WRITE = JITA_SETTINGS_WRITE;